function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { isFunction } from '@cloud-sn/v-utils';
import Pager from './pager.js';
import Options from './options.js';
import { buildComponentName } from '../utils';
import Icon from '../icon';
import Select from '../select';
var DEFAULT_LOCALE = {
  items_per_page: '条/页',
  jump_to: '跳至',
  page: '页',
  prev_page: '上一页',
  next_page: '下一页',
  prev_5: '向前 5 页',
  next_5: '向后 5 页',
  prev_3: '向前 3 页',
  next_3: '向后 3 页',
  confirm: '确定'
};

function defaultItemRender(page, type, node) {
  return node; // return `<a>${type === 'page' ? page : ''}</a>`;
}

function noop() {}

function isInteger(val) {
  return typeof val === 'number' && Number.isFinite(val) && Math.floor(val) === val;
}

var pagerTpl = {
  type: 'pager',
  prefixCls: '',
  onClick: noop,
  onKeyPress: noop,
  key: 1,
  page: 1,
  active: false,
  showTitle: true
};
var __vue_script__ = {
  name: buildComponentName('Pagination'),
  components: {
    Pager: Pager,
    Options: Options,
    UxSelect: Select,
    UxOption: Select.Option,
    VNodes: {
      functional: true,
      render: function render(h, ctx) {
        return ctx.props.vnodes;
      }
    }
  },
  props: {
    prefixCls: {
      type: String,
      default: 'ux-pagination'
    },
    current: {
      type: Number,
      default: 1
    },
    total: {
      type: Number,
      required: true,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 10
    },
    size: {
      type: String,
      default: ''
    },
    simple: {
      type: Boolean,
      default: false
    },
    showSizeChanger: {
      type: Boolean,
      default: false
    },
    pageSizeOptions: {
      type: Array,
      default: function _default() {
        return [10, 20, 30];
      }
    },
    styles: {
      type: Object,
      default: null
    },
    className: {
      type: String,
      default: ''
    },
    showLessItems: {
      type: Boolean,
      default: false
    },
    showQuickJumper: {
      type: Boolean,
      default: false
    },
    showQuickJumperConfirmBtn: {
      type: Boolean,
      default: true
    },
    showTitle: {
      type: Boolean,
      default: true
    },
    showBeforeTotal: {
      type: Function,
      default: noop
    },
    showAfterTotal: {
      type: Function,
      default: noop
    },
    itemRender: {
      type: Function,
      default: defaultItemRender
    },
    theme: {
      type: String,
      default: 'light'
    },
    mode: {
      type: String,
      default: 'normal',
      validator: function validator(val) {
        return ['normal', 'stream'].indexOf(val) > -1;
      }
    },
    pageBufferSize: {
      type: Number,
      default: undefined
    },
    locale: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    var _this = this;

    var prefixCls = this.prefixCls,
        showLessItems = this.showLessItems,
        genTitle = this.genTitle,
        locale = this.locale;

    var mergedLocale = _objectSpread({}, DEFAULT_LOCALE, {}, locale);

    return {
      noop: noop,
      pageNo: +this.current,
      prevPageNo: 0,
      nextPageNo: 0,
      usedPageSize: this.pageSize,
      mergedLocale: mergedLocale,
      prevDisabled: false,
      nextDisabled: false,
      pagers: [],
      jumpPrevObj: {
        type: 'jump',
        title: genTitle(showLessItems ? mergedLocale.prev_3 : mergedLocale.prev_5),
        key: 'prev',
        classes: "".concat(prefixCls, "-jump-prev"),
        onClick: this.jumpPrev,
        onKeyPress: this.jumpPrev,
        getPage: this.getJumpPrevPage,
        jumpIcon: function jumpIcon() {
          return _this.jumpPrevIcon;
        }
      },
      jumpNextObj: {
        type: 'jump',
        title: genTitle(showLessItems ? mergedLocale.next_3 : mergedLocale.next_5),
        key: 'next',
        classes: "".concat(prefixCls, "-jump-next"),
        onClick: this.jumpNext,
        onKeyPress: this.jumpNext,
        getPage: this.getJumpNextPage,
        jumpIcon: function jumpIcon() {
          return _this.jumpNextIcon;
        }
      }
    };
  },
  computed: {
    simpleClasses: function simpleClasses() {
      var _ref;

      var prefixCls = this.prefixCls;
      return _ref = {}, _defineProperty(_ref, prefixCls, true), _defineProperty(_ref, "".concat(prefixCls, "-simple"), true), _ref;
    },
    simpleSepClasses: function simpleSepClasses() {
      var prefixCls = this.prefixCls;
      return _defineProperty({}, "".concat(prefixCls, "-sep"), true);
    },
    sizeChangerClasses: function sizeChangerClasses() {
      var prefixCls = this.prefixCls;
      return _defineProperty({}, "".concat(prefixCls, "-options-size-changer"), true);
    },
    beforeTotalClasses: function beforeTotalClasses() {
      var prefixCls = this.prefixCls;
      return _defineProperty({}, "".concat(prefixCls, "-before-total-text"), true);
    },
    afterTotalClasses: function afterTotalClasses() {
      var prefixCls = this.prefixCls;
      return _defineProperty({}, "".concat(prefixCls, "-after-total-text"), true);
    },
    prevClasses: function prevClasses() {
      var _ref6;

      var prefixCls = this.prefixCls;
      return _ref6 = {}, _defineProperty(_ref6, "".concat(prefixCls, "-prev"), true), _defineProperty(_ref6, "".concat(prefixCls, "-disabled"), this.prevDisabled), _ref6;
    },
    nextClasses: function nextClasses() {
      var _ref7;

      var prefixCls = this.prefixCls;
      return _ref7 = {}, _defineProperty(_ref7, "".concat(prefixCls, "-next"), true), _defineProperty(_ref7, "".concat(prefixCls, "-disabled"), this.nextDisabled), _ref7;
    },
    classes: function classes() {
      var _ref8;

      var prefixCls = this.prefixCls;
      return _ref8 = {}, _defineProperty(_ref8, prefixCls, true), _defineProperty(_ref8, "mini", this.size === 'small'), _ref8;
    },
    totalPage: function totalPage() {
      var pageSize = this.usedPageSize,
          total = this.total;
      return Math.floor((total - 1) / pageSize) + 1;
    },
    beforeTotalLiteral: function beforeTotalLiteral() {
      return this.genTotalLiteral(this.showBeforeTotal);
    },
    afterTotalLiteral: function afterTotalLiteral() {
      return this.genTotalLiteral(this.showAfterTotal);
    },
    prevIcon: function prevIcon() {
      var renderPrevIcon = this.renderPrevIcon,
          getIconNode = this.getIconNode;
      return getIconNode(renderPrevIcon);
    },
    nextIcon: function nextIcon() {
      var renderNextIcon = this.renderNextIcon,
          getIconNode = this.getIconNode;
      return getIconNode(renderNextIcon);
    },
    jumpPrevIcon: function jumpPrevIcon() {
      var renderJumpPrevIcon = this.renderJumpPrevIcon,
          getIconNode = this.getIconNode;
      return getIconNode(renderJumpPrevIcon);
    },
    jumpNextIcon: function jumpNextIcon() {
      var renderJumpNextIcon = this.renderJumpNextIcon,
          getIconNode = this.getIconNode;
      return getIconNode(renderJumpNextIcon);
    }
  },
  watch: {
    pageSize: function pageSize(newVal, val) {
      if (newVal !== val) {
        this.setPageSize();
      }
    },
    totalPage: function totalPage() {
      this.reRender();
    },
    current: function current(nVal, oVal) {
      // 再加一层判断，防止操作翻页后在change事件中修改current，又被watch到触发render
      if (nVal && nVal !== oVal && nVal !== this.pageNo) {
        this.pageNo = nVal;
        this.reRender();
      }
    }
  },
  created: function created() {
    this.setPageSize();
    this.reRender();
  },
  methods: {
    getPageItem: function getPageItem(item) {
      var h = this.$createElement;
      return h("a", [item.page]);
    },
    getIconNode: function getIconNode(fn) {
      var h = this.$createElement;
      var $props = this.$props,
          prefixCls = this.prefixCls;
      return isFunction(fn) ? fn(_objectSpread({}, $props)) : h("a", {
        "class": "".concat(prefixCls, "-item-link")
      });
    },
    genTotalLiteral: function genTotalLiteral(cb) {
      var total = this.total,
          pageNo = this.pageNo,
          pageSize = this.usedPageSize,
          totalPage = this.totalPage; // 当前页对应的条目范围

      var range = [pageNo > 0 ? (pageNo - 1) * pageSize + 1 : 0, pageNo * pageSize > total ? total : pageNo * pageSize];
      return cb(total, pageSize, totalPage, pageNo, range);
    },
    genTitle: function genTitle(title) {
      return this.showTitle ? title : '';
    },
    resetPageNo: function resetPageNo() {
      var pageNo = this.pageNo,
          totalPage = this.totalPage;

      if (pageNo < 1) {
        this.pageNo = 1;
      } else if (pageNo > totalPage) {
        this.pageNo = totalPage;
      } else {
        this.pageNo = pageNo;
      }
    },
    hasPrev: function hasPrev() {
      return this.pageNo > 1;
    },
    hasNext: function hasNext() {
      return this.pageNo < this.totalPage;
    },
    jumpPrev: function jumpPrev() {
      return this.handleChange(this.getJumpPrevPage());
    },
    jumpNext: function jumpNext() {
      return this.handleChange(this.getJumpNextPage());
    },
    getJumpPrevPage: function getJumpPrevPage() {
      var pageNo = this.pageNo,
          showLessItems = this.showLessItems;
      return Math.max(1, pageNo - (showLessItems ? 3 : 5));
    },
    getJumpNextPage: function getJumpNextPage() {
      var pageNo = this.pageNo,
          showLessItems = this.showLessItems,
          totalPage = this.totalPage;
      return Math.min(totalPage, pageNo + (showLessItems ? 3 : 5));
    },
    prev: function prev() {
      if (this.hasPrev()) {
        this.handleChange(this.pageNo - 1);
      }
    },
    next: function next() {
      if (this.hasNext()) {
        this.handleChange(this.pageNo + 1);
      }
    },
    handleChange: function handleChange(page) {
      var totalPage = this.totalPage,
          pageNo = this.pageNo,
          usedPageSize = this.usedPageSize;
      var nPage = page;

      if (!isInteger(page)) {
        return;
      }

      if (nPage === pageNo) return;

      if (nPage < 1) {
        nPage = 1;
      }

      if (nPage > totalPage) {
        nPage = totalPage;
      }

      this.pageNo = nPage;
      this.render();
      this.$emit('change', nPage, usedPageSize);
    },
    render: function render() {
      var simple = this.simple,
          pageBufferSize = this.pageBufferSize,
          totalPage = this.totalPage,
          current = this.pageNo,
          prefixCls = this.prefixCls,
          showTitle = this.showTitle,
          jumpPrevObj = this.jumpPrevObj,
          jumpNextObj = this.jumpNextObj,
          handleChange = this.handleChange,
          showLessItems = this.showLessItems,
          mode = this.mode;
      var list = [];
      this.prevDisabled = !this.hasPrev();
      this.nextDisabled = !this.hasNext(); // 简单模式 有自身的逻辑

      if (simple) {
        return;
      }

      var bufferSize = showLessItems ? 1 : 2;

      if (mode === 'stream') {
        bufferSize = 4;
      }

      var pbs = Number(pageBufferSize);

      if (typeof pbs === 'number' && pbs > 0) {
        bufferSize = pbs;
      }

      if (mode !== 'stream' && totalPage <= 5 + bufferSize * 2) {
        var _loop = function _loop(i) {
          list.push(_objectSpread({}, pagerTpl, {}, {
            prefixCls: prefixCls,
            onClick: function onClick() {
              handleChange(i);
            },
            onKeyPress: function onKeyPress() {
              handleChange(i);
            },
            key: i,
            page: i,
            active: i === current,
            showTitle: showTitle
          }));
        };

        for (var i = 1; i <= totalPage; i += 1) {
          _loop(i);
        }
      } else {
        var left = Math.max(1, current - bufferSize);
        var right = Math.min(totalPage, current + bufferSize); // 选中开始几位时, 按钮个数保持最少pageBufferSize*2+1个

        if (current < bufferSize + 1) {
          // prettier-ignore
          right = 1 + bufferSize * 2;
        } // 选中最后几页时,按钮个数保证最少pageBufferSize*2+1个


        if (current > totalPage - bufferSize) {
          // prettier-ignore
          left = totalPage - bufferSize * 2;
        }

        var _loop2 = function _loop2(_i) {
          list.push(_objectSpread({}, pagerTpl, {}, {
            prefixCls: prefixCls,
            onClick: function onClick() {
              handleChange(_i);
            },
            onKeyPress: function onKeyPress() {
              handleChange(_i);
            },
            key: _i,
            page: _i,
            active: _i === current,
            showTitle: showTitle
          }));
        };

        for (var _i = left; _i <= right; _i += 1) {
          _loop2(_i);
        } // stream 模式 不新增 省略条和 首尾节点


        if (mode !== 'stream') {
          var firstPager = _objectSpread({}, pagerTpl, {}, {
            prefixCls: prefixCls,
            onClick: function onClick() {
              handleChange(1);
            },
            onKeyPress: function onKeyPress() {
              handleChange(1);
            },
            key: 1,
            page: 1,
            showTitle: showTitle
          });

          var lastPager = _objectSpread({}, pagerTpl, {}, {
            prefixCls: prefixCls,
            onClick: function onClick() {
              handleChange(totalPage);
            },
            onKeyPress: function onKeyPress() {
              handleChange(totalPage);
            },
            key: totalPage,
            page: totalPage,
            showTitle: showTitle
          }); // 最少4个按钮时才显示 省略条


          if (current >= bufferSize * 2 + 1 && current !== 3) {
            list[0].classes = "".concat(prefixCls, "-item-after-jump-prev");
            list.unshift(jumpPrevObj);
          }

          if (current <= totalPage - bufferSize * 2 && current !== totalPage - 2) {
            list[list.length - 1].classes = "".concat(prefixCls, "-item-after-jump-next");
            list.push(jumpNextObj);
          }

          if (left !== 1) {
            list.unshift(firstPager);
          }

          if (right !== totalPage) {
            list.push(lastPager);
          }
        }
      }

      this.prevPageNo = current - 1 > 0 ? current - 1 : 1;
      this.nextPageNo = current + 1 > totalPage ? totalPage : current + 1;
      this.pagers = list;
    },
    reRender: function reRender() {
      var resetPageNo = this.resetPageNo,
          render = this.render;
      resetPageNo();
      render();
    },
    renderPrevIcon: function renderPrevIcon() {
      var h = this.$createElement;
      var prefixCls = this.prefixCls;
      return h("a", {
        "class": "".concat(prefixCls, "-item-link")
      }, [h(Icon, {
        "attrs": {
          "type": "left"
        }
      })]);
    },
    renderNextIcon: function renderNextIcon() {
      var h = this.$createElement;
      var prefixCls = this.prefixCls;
      return h("a", {
        "class": "".concat(prefixCls, "-item-link")
      }, [h(Icon, {
        "attrs": {
          "type": "right"
        }
      })]);
    },
    renderJumpPrevIcon: function renderJumpPrevIcon() {
      var h = this.$createElement;
      var prefixCls = this.prefixCls;
      return h("a", {
        "class": "".concat(prefixCls, "-item-link")
      }, [h("div", {
        "class": "".concat(prefixCls, "-item-container")
      }, [h(Icon, {
        "class": "".concat(prefixCls, "-item-link-icon"),
        "attrs": {
          "type": "double_left"
        }
      }), h("span", {
        "class": "".concat(prefixCls, "-item-ellipsis")
      }, ["\u2022\u2022\u2022"])])]);
    },
    renderJumpNextIcon: function renderJumpNextIcon() {
      var h = this.$createElement;
      var prefixCls = this.prefixCls;
      return h("a", {
        "class": "".concat(prefixCls, "-item-link")
      }, [h("div", {
        "class": "".concat(prefixCls, "-item-container")
      }, [h(Icon, {
        "class": "".concat(prefixCls, "-item-link-icon"),
        "attrs": {
          "type": "double_right"
        }
      }), h("span", {
        "class": "".concat(prefixCls, "-item-ellipsis")
      }, ["\u2022\u2022\u2022"])])]);
    },
    setPageSize: function setPageSize() {
      var showSizeChanger = this.showSizeChanger,
          pageSizeOptions = this.pageSizeOptions,
          pageSize = this.pageSize;

      if (showSizeChanger && pageSizeOptions.indexOf(pageSize) === -1) {
        this.usedPageSize = +pageSizeOptions[0];
      } else {
        this.usedPageSize = +pageSize;
      }
    },
    pageSizeChange: function pageSizeChange() {
      this.resetPageNo();
      this.$emit('page-size-change', this.pageNo, this.usedPageSize);
    }
  }
};
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.simple ? _c('ul', {
    class: [_vm.simpleClasses, _vm.className],
    style: _vm.styles
  }, [_vm.showBeforeTotal !== _vm.noop ? _c('li', {
    class: _vm.beforeTotalClasses,
    domProps: {
      "innerHTML": _vm._s(_vm.beforeTotalLiteral)
    }
  }) : _vm._e(), _c('li', {
    class: _vm.prevClasses,
    attrs: {
      "title": _vm.genTitle(_vm.mergedLocale.prev_page),
      "tabindex": "0"
    },
    on: {
      "click": _vm.prev,
      "keypress": function keypress($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }

        return _vm.prev($event);
      }
    }
  }, [_c('v-nodes', {
    attrs: {
      "vnodes": _vm.itemRender(_vm.prevPageNo, 'prev', _vm.prevIcon)
    }
  })], 1), _c('li', {
    class: _vm.simpleSepClasses
  }), _c('li', {
    class: _vm.nextClasses,
    attrs: {
      "title": _vm.genTitle(_vm.mergedLocale.next_page),
      "tabindex": "0"
    },
    on: {
      "click": _vm.next,
      "keypress": function keypress($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }

        return _vm.next($event);
      }
    }
  }, [_c('v-nodes', {
    attrs: {
      "vnodes": _vm.itemRender(_vm.nextPageNo, 'next', _vm.nextIcon)
    }
  })], 1), _vm.showAfterTotal !== _vm.noop ? _c('li', {
    class: _vm.afterTotalClasses,
    domProps: {
      "innerHTML": _vm._s(_vm.afterTotalLiteral)
    }
  }) : _vm._e()]) : _c('ul', {
    class: [_vm.classes, _vm.className],
    style: _vm.styles,
    attrs: {
      "unselectable": "unselectable"
    }
  }, [_vm.showBeforeTotal !== _vm.noop ? _c('li', {
    class: _vm.beforeTotalClasses,
    domProps: {
      "innerHTML": _vm._s(_vm.beforeTotalLiteral)
    }
  }) : _vm._e(), _vm.showSizeChanger ? _c('li', {
    staticClass: "ux-pagination-options-size-changer"
  }, [_c('ux-select', {
    on: {
      "change": _vm.pageSizeChange
    },
    model: {
      value: _vm.usedPageSize,
      callback: function callback($$v) {
        _vm.usedPageSize = $$v;
      },
      expression: "usedPageSize"
    }
  }, _vm._l(_vm.pageSizeOptions, function (item) {
    return _c('ux-option', {
      key: item,
      attrs: {
        "value": item,
        "label": item + " " + _vm.mergedLocale.items_per_page
      }
    });
  }), 1)], 1) : _vm._e(), _c('li', {
    class: _vm.prevClasses,
    attrs: {
      "title": _vm.genTitle(_vm.mergedLocale.prev_page),
      "tabindex": "0"
    },
    on: {
      "click": _vm.prev,
      "keypress": function keypress($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }

        return _vm.prev($event);
      }
    }
  }, [_c('v-nodes', {
    attrs: {
      "vnodes": _vm.itemRender(_vm.prevPageNo, 'prev', _vm.prevIcon)
    }
  })], 1), _vm._l(_vm.pagers, function (item) {
    return [item.type === 'jump' ? _c('li', {
      key: item.key,
      class: item.classes,
      attrs: {
        "title": item.title,
        "tabindex": "0"
      },
      on: {
        "click": item.onClick,
        "keypress": item.onKeyPress
      }
    }, [_c('v-nodes', {
      attrs: {
        "vnodes": _vm.itemRender(item.getPage(), "jump-" + item.key, item.jumpIcon())
      }
    })], 1) : _vm._e(), item.type === 'pager' ? _c('pager', {
      key: item.key,
      attrs: {
        "page": item.page,
        "active": item.active,
        "show-title": item.showTitle,
        "root-prefix-cls": item.prefixCls,
        "class-name": item.classes
      },
      nativeOn: {
        "click": function click($event) {
          return item.onClick($event);
        },
        "keypress": function keypress($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
            return null;
          }

          return item.onKeyPress($event);
        }
      }
    }, [_c('v-nodes', {
      attrs: {
        "vnodes": _vm.itemRender(item.page, 'page', _vm.getPageItem(item))
      }
    })], 1) : _vm._e()];
  }), _c('li', {
    class: _vm.nextClasses,
    attrs: {
      "title": _vm.genTitle(_vm.mergedLocale.next_page),
      "tabindex": "0"
    },
    on: {
      "click": _vm.next,
      "keypress": function keypress($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }

        return _vm.next($event);
      }
    }
  }, [_c('v-nodes', {
    attrs: {
      "vnodes": _vm.itemRender(_vm.nextPageNo, 'next', _vm.nextIcon)
    }
  })], 1), _vm.showAfterTotal !== _vm.noop ? _c('li', {
    class: _vm.afterTotalClasses,
    domProps: {
      "innerHTML": _vm._s(_vm.afterTotalLiteral)
    }
  }) : _vm._e(), _c('options', {
    attrs: {
      "root-prefix-cls": _vm.prefixCls,
      "have-quick-jumper": _vm.showQuickJumper,
      "locale": _vm.mergedLocale,
      "current": _vm.pageNo,
      "have-confirm-btn": _vm.showQuickJumperConfirmBtn
    },
    on: {
      "on-quick-jumper": _vm.handleChange
    }
  })], 2);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* component normalizer */

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  var component = (typeof script === 'function' ? script.options : script) || {}; // For security concerns, we use only base name in production mode.

  component.__file = "pagination.js";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  if (false) {
    var hook;

    if (false) {
      // In SSR.
      hook = function hook(context) {
        // 2.3 injection
        context = context || // cached call
        this.$vnode && this.$vnode.ssrContext || // stateful
        this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
        // 2.2 with runInNewContext: true

        if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
          context = __VUE_SSR_CONTEXT__;
        } // inject component styles


        if (style) {
          style.call(this, createInjectorSSR(context));
        } // register component module identifier for async chunk inference


        if (context && context._registeredComponents) {
          context._registeredComponents.add(moduleIdentifier);
        }
      }; // used by ssr in case component is cached and beforeCreate
      // never gets called


      component._ssrRegister = hook;
    } else if (style) {
      hook = shadowMode ? function (context) {
        style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
      } : function (context) {
        style.call(this, createInjector(context));
      };
    }

    if (hook !== undefined) {
      if (component.functional) {
        // register for functional component in vue file
        var originalRender = component.render;

        component.render = function renderWithStyleInjection(h, context) {
          hook.call(context);
          return originalRender(h, context);
        };
      } else {
        // inject component registration as beforeCreate hook
        var existing = component.beforeCreate;
        component.beforeCreate = existing ? [].concat(existing, hook) : [hook];
      }
    }
  }

  return component;
}
/* style inject */

/* style inject SSR */

/* style inject shadow dom */


var __vue_component__ = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

export default __vue_component__;